module.exports = __webpack_public_path__ + "static/media/season-img2.3a1f021a.jpg";